<template lang="html">
  <div class="ui-button" :style="style" :class="className" @click="onClick">
    <slot></slot>
  </div>
</template>

<script>
import { StyleTransfer } from "../../lib/styleTransfer";
const styleTransfer = new StyleTransfer(750, 10)

export default {
  name: 'UiButton',

  props: {
    // 类型 normal | white | disable | red | green | blue
    type: {
      type: String,
      default: 'normal'
    },

    // 单位 rem | px等其他, 目前只有 rem 会做处理
    unit: {
      type: String,
      default: 'rem'
    },

    // 高
    height: {
      type: [String, Number],
      default: 78
    },

    // 宽
    width: [String, Number],

    // 字号
    fontSize: {
      type: [String, Number],
      default: 34
    },

    // 是否行内
    inlineBlock: Boolean,

    // 是否用阴影
    shadow: Boolean,

    // 是否是圆角
    round: Boolean,

    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    style () {
      const result = {}
      styleTransfer.parseStyle(result, this.height, 'height', this.unit)
      styleTransfer.parseStyle(result, this.height, 'line-height', this.unit)
      styleTransfer.parseStyle(result, this.width, 'width', this.unit)
      styleTransfer.parseStyle(result, this.fontSize, 'font-size', this.unit)
      if (this.inlineBlock) {
        result.display = 'inline-block'
      }
      if (this.round) {
        styleTransfer.parseStyle(result, this.height / 2, 'border-radius', this.unit)
      }
      return result
    },

    className () {
      const result = []
      if (this.type) {
        result.push(`ui-button-${this.type}`)
      }
      if (this.shadow) {
        result.push('ui-button-shadow')
      }
      if (this.disabled) {
        result.push(`ui-button-${this.type}-disabled`)
      }
      return result
    }
  },

  methods: {
    onClick () {
      if (!this.disabled) {
        this.$emit('click')
      } else {
        this.$emit('disabled-click')
      }
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.ui-button {
  border-radius: use(6);
  text-align: center;
  letter-spacing: use(1.6);
  box-sizing: border-box;

  &-normal {
    background:rgba(253,86,0,1);
    border-radius:43px;
    color: #fff;
    font-size: rem(36);

    &-disabled {
      background: #CECECE;
    }
  }

  &-gray {
    background: #CECECE;
    // padding: 0 rem(5);
    color: #fff;
  }

  &-blue {
    background: linear-gradient(to right, #56C3F2, #3BA8FF);
    // padding: 0 rem(5);
    color: #fff;
  }

  &-white {
    border: 1px solid $globalColor;
    background-color: #fff;
    color: $globalColor;

    &-disabled {
      background-color: #999999;
      border-color: #999999;
      color: #fff;
    }
  }

  &-disable {
    background-color: #bfbfbf;
    color: #fff;
  }

  &-shadow {
    box-shadow: 0 use(10) use(15) rgba(#F38738, .32);
  }

  &-gray {
    background: #CECECE;
    // padding: 0 rem(5);
    color: #fff;
  }

  &-red {
    background: linear-gradient(to right ,#fe5c00, #f44b00);
    // padding: 0 rem(5);
    min-width: rem(240);
    color: #fff;
  }

  &-green {
    background-color: #42CA59;
    color: #fff;
  }

  // 畅学卡专用样式
  &-privilege {
    color: #fff;
    background: linear-gradient(to right ,#fca300, #f46d00)
  }
}
</style>
